import React from 'react';

const Loading = () => {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      color: 'white',
      fontFamily: 'Senobi Gothic, sans-serif'
    }}>
      <div style={{
        width: '80px',
        height: '80px',
        border: '4px solid rgba(255, 255, 255, 0.3)',
        borderTop: '4px solid white',
        borderRadius: '50%',
        animation: 'spin 1s linear infinite',
        marginBottom: '20px'
      }}></div>

      <h2 style={{
        fontSize: '24px',
        marginBottom: '10px',
        fontWeight: '600'
      }}>Loading...</h2>

      <p style={{
        fontSize: '16px',
        opacity: '0.8',
        textAlign: 'center'
      }}>ポートフォリオを読み込み中</p>

      <style jsx>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default Loading;
